export default {
  pager: (state) => state.pager,
  isChecked: (state) => state.isChecked,
  dashboardName: (state) => state.dashboardName,
  dashboardComponent: (state) => state.dashboardComponent,
  dashboardComponents: (state) => state.dashboardComponents,
  mediaItem: (state) => state.mediaItem,
  media: (state) => state.media,
  memberStatus: (state) => state.memberStatus,
}
